import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid2';
import { ui } from '../../interfaces/interfaces';
import useDebugInformation from "../../hooks/useDebugInformation";
import { useAppSelector } from "@store/hooks";

const a11yCombosProps = (name: ComboProps["name"], onChange: any, options: any, getOptionLabel: any, isOptionEqualToValue: any, sm: any, value: any) => {
    return {
        sm,
        id: `combo-box-${name.toLowerCase()}`,
        name: `ProblemCombo${name}`,
        sx: ui[`ProblemCombo${name}`] ? ({
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "green"
            },
        }) : ({
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "red"
            },
        }),
        // error: ui["ProblemCombo" + name] ? false : true,
        options,
        // onBlur: onChange,
        getOptionLabel,
        isOptionEqualToValue,
        value,
        onChange,
        "aria-controls": `action-combo-${name.toLowerCase()}`,
    };
}

type ComboProps = {
    name: "Category" | "Job" | "Trade"
    onChange: any;
    options: any;
    getOptionLabel: any;
    isOptionEqualToValue: any;
    sm: any;
    value: any;
    inputRef?: any;
}

const ComboDropDown: React.FC<ComboProps> = ({ name, onChange, options, getOptionLabel, isOptionEqualToValue, sm, value, inputRef }) => {
    const error = useAppSelector(({ ui }) => ui[`ProblemCombo${name}`])

    useDebugInformation("ComboDropDown", { name, onChange, options, getOptionLabel, isOptionEqualToValue, sm, value, error })
    return (
        (<Grid
            size={{
                xs: 12,
                sm
            }}>
            <Autocomplete {...a11yCombosProps(name, onChange, options, getOptionLabel, isOptionEqualToValue, sm, value)}
                renderInput={(params) => <TextField {...params} label={name} variant="outlined" autoComplete="off" error={error ? false : true} color={error ? "success" : "primary"} inputRef={inputRef} />}
            />
        </Grid>)
    );
}

export default React.memo(ComboDropDown)